<p-card>
  <div class="summary-header" (click)="toggleSummaryCards()">

    <div class="dashboard-toggle">

      <button pButton type="button" icon="fa fa-table" label="Data" class="p-button-sm"
        [ngClass]="dashboardView == 'table' ? 'active-btn' : 'inactive-btn'"
        (click)="switchDashboard('table');$event.stopPropagation()">
      </button>

      <button pButton type="button" icon="fa fa-line-chart" label="Charts" class="p-button-sm ml-2"
        [ngClass]="dashboardView == 'analytics' ? 'active-btn' : 'inactive-btn'"
        (click)="switchDashboard('analytics');$event.stopPropagation()">
      </button>

    </div>
    <div class="summary-title-area">
      <!-- <i class="fa" [ngClass]="showSummaryCards ? 'fa-chevron-down' : 'fa-chevron-right'">
      </i>

      <i class="fa fa-bar-chart text-primary"></i>

      <span class="title">
        Error Logs Summary
      </span> -->

      <!-- <span class="badge">
        8 Metrics
      </span> -->

      <div class="summary-mini-metrics">

        <span (click)="show('Todays Open Logs','');$event.stopPropagation()" class="mini-chip open"
          pTooltip="Click to view open errors generated today" tooltipPosition="bottom"
          *ngIf="summaryCards.todayOpenLogs > 0">
          <i class="fa fa-exclamation-circle"></i>
          {{summaryCards.todayOpenLogs}} Open
        </span>

        <span (click)="show('Todays Closed Logs','');$event.stopPropagation()" class="mini-chip closed"
          pTooltip="Click to view errors Closed Today" tooltipPosition="bottom"
          *ngIf="summaryCards.todayClosedLogs > 0">
          <i class="fa fa-check-circle"></i>
          {{summaryCards.todayClosedLogs}} Closed
        </span>

        <span (click)="show('Todays Logs','');$event.stopPropagation()" class="mini-chip today"
          pTooltip="Click to view Errors Occured Today" tooltipPosition="bottom"
          *ngIf="!showSummaryCards && summaryCards.todaysLogs > 0">
          <i class="fa fa-calendar"></i>
          {{summaryCards.todaysLogs}} Today
        </span>

        <span (click)="show('Product with Highest Open Logs','');$event.stopPropagation()" class="mini-chip champion"
          pTooltip="Click to view Product with highest open errors" tooltipPosition="bottom" *ngIf="!showSummaryCards">
          <i class="fa fa-trophy"></i>
          {{summaryCards.productWithHighestOpenLog}}
        </span>

        <span class="mini-chip streak" [ngClass]="getErrorStreakClass()" pTooltip="Time since the last error was logged"
          tooltipPosition="bottom">
          <i class="fa fa-shield"></i>
          <div class="summary-label">Error Free</div>
          <div class="summary-value">
            {{ summaryCards.errorFreeStreak }}
          </div>
        </span>

        <span class="mini-chip average" pTooltip="Average Errors Per Day" tooltipPosition="bottom">
          <i class="fa fa-line-chart"></i>
          {{summaryCards.averageErrorsPerDay}}/day
        </span>

        <!-- <span (click)="show('Current Week Logs','');$event.stopPropagation()" class="mini-chip weeklogs"
          pTooltip="Total Errors Logged in this week" tooltipPosition="bottom">
          <i class="fa fa-calendar-week"></i>
          {{summaryCards.thisWeekLogs}} This Week
        </span> -->

        <span class="mini-chip" [ngClass]="{
              'resolution-good': summaryCards.resolutionRate >= 80,
              'resolution-warning': summaryCards.resolutionRate >= 60 && summaryCards.resolutionRate < 80,
              'resolution-attention': summaryCards.resolutionRate >= 40 && summaryCards.resolutionRate < 60,
              'resolution-critical': summaryCards.resolutionRate < 40
            }" pTooltip="Overall Error Resolution Rate" tooltipPosition="bottom">

          <i class="fa" [ngClass]="{
              'fa-check-circle': summaryCards.resolutionRate >= 80,
              'fa-thumbs-up': summaryCards.resolutionRate >= 60 && summaryCards.resolutionRate < 80,
              'fa-exclamation-triangle': summaryCards.resolutionRate >= 40 && summaryCards.resolutionRate < 60,
              'fa-times-circle': summaryCards.resolutionRate < 40
            }">
          </i>
          {{summaryCards.resolutionRate | number:'1.0-2'}}%
        </span>
      </div>
    </div>

    <small class="text-muted">
      Click to {{showSummaryCards ? 'Collapse' : 'Expand'}}
    </small>

  </div>

  <div *ngIf="showSummaryCards">
    <div *ngIf="showStatusHint" class="status-banner">
      <i class="fa fa-info-circle"></i>

      <span>
        <i class="fa fa-hand-pointer-o"></i>
        The summary cards below are clickable. Click a card to view its corresponding details.
      </span>

      <i class="fa fa-times close-banner" pTooltip="Dismiss" tooltipPosition="left" (click)="showStatusHint = false">
      </i>
    </div>
    <div class="grid mb-3">
      <div class="col-12 md:col flex-card">
        <p-card (click)="show('Open Logs','')" pTooltip="Click to view all open logs"
          styleClass="summary-card open-card">

          <div class="summary-title">
            <i class="fa fa-exclamation-circle"></i>
            Open Errors
          </div>

          <div class="summary-metric">
            <span class="summary-value">
              {{summaryCards.openLogs}}
            </span>

            <span class="summary-trend positive" *ngIf="summaryCards.todayOpenLogs > 0">
              <i class="fa fa-arrow-up"></i>
              +{{summaryCards.todayOpenLogs}} Today
            </span>
          </div>
        </p-card>
      </div>

      <div class="col-12 md:col flex-card">
        <p-card styleClass="summary-card closed-card" (click)="show('Closed Logs','')"
          pTooltip="Click to view all closed logs">

          <div class="summary-title">
            <i class="fa fa-check-circle"></i>
            Closed Errors
          </div>

          <div class="summary-metric">
            <span class="summary-value">
              {{summaryCards.closedLogs}}
            </span>

            <span class="summary-trend success" *ngIf="summaryCards.todayClosedLogs > 0">
              <i class="fa fa-arrow-up"></i>
              +{{summaryCards.todayClosedLogs}} Today
            </span>
          </div>

        </p-card>
      </div>

      <div class="col-12 md:col flex-card">
        <p-card styleClass="summary-card api-card" (click)="show('Top API','')"
          pTooltip="Click to view all occurrences of the top failing API">
          <div class="summary-title">
            <i class="fa fa-globe"></i>
            Top Failing API
          </div>
          <div class="summary-text">
            {{summaryCards.topFailingApi}}
          </div>
        </p-card>
      </div>

      <div class="col-12 md:col flex-card">
        <p-card styleClass="summary-card page-card" (click)="show('Most Affected Page','')"
          pTooltip="Click to view all occurrences of the most affected page">
          <div class="summary-title">
            <i class="fa fa-file-text-o"></i>
            Most Affected Page
          </div>
          <div class="summary-text">
            {{summaryCards.mostAffectedPage}}
          </div>
        </p-card>
      </div>

      <div class="col-12 md:col flex-card">
        <p-card styleClass="summary-card lastlog-card" (click)="show('Last Log','')"
          pTooltip="Click to view last open log">
          <div class="summary-title">
            <i class="fa fa-clock-o"></i>
            Latest Error - {{summaryCards.lastLog}}
          </div>
          <div class="summary-text">
            <div class="last-log-time">
              {{summaryCards.lastLogTime}}
            </div>
          </div>
        </p-card>
      </div>
    </div>
    <div class="grid mb-3">

      <div class="col-12 md:col flex-card">
        <p-card styleClass="summary-card today-card" (click)="show('Todays Logs','')"
          pTooltip="Click to view todays logs">
          <div class="summary-title">
            <i class="fa fa-calendar"></i>
            Todays Errors
          </div>

          <div class="summary-value">
            {{summaryCards.todaysLogs}}
          </div>
        </p-card>
      </div>

      <!-- <div class="col-12 md:col flex-card">
        <p-card styleClass="summary-card average-card">
          <div class="summary-title">
            <i class="fa fa-line-chart"></i>
            Average Errors Per Day
          </div>

          <div class="summary-value">
            {{summaryCards.averageErrorsPerDay}}
          </div>
        </p-card>
      </div> -->

      <div class="col-12 md:col flex-card">
        <p-card styleClass="summary-card product-card" pTooltip="Click to view all errors for the product"
          (click)="show('Most Affected Product','')">
          <div class="summary-title">
            <i class="fa fa-cubes"></i>
            Most Affected Product
          </div>
          <div class="summary-value">
            {{summaryCards.mostAffectedProduct}}
          </div>
        </p-card>
      </div>
      <div class="col-12 md:col flex-card">
        <p-card styleClass="summary-card champion-card"
          pTooltip="Click to view the product with the highest number of open errors"
          (click)="show('Product with Highest Open Logs','')">
          <div class="summary-title">
            <i class="fa fa-trophy"></i>
            Open Error Champion
          </div>

          <div class="summary-value">
            {{summaryCards.productWithHighestOpenLog}}
          </div>
        </p-card>
      </div>
      <div class="col-12 md:col flex-card">
        <p-card styleClass="summary-card insight-card" pTooltip="Click to see next random insight"
          (click)="getRandomInsight()">

          <div class="summary-title">
            <i [class]="randomInsight.icon"></i>
            {{ randomInsight.title }}
          </div>

          <div class="summary-value">
            {{ randomInsight.value }}
          </div>

          <div class="insight-footer">
            <i class="fa fa-refresh"></i>
            Click for another insight
          </div>

        </p-card>
      </div>
    </div>
  </div>

  <div *ngIf="dashboardView=='table'">
    <p-tabView>



      <p-tabPanel header="Application Logs">

        <div class=" mr-0 tablehiegt">
          <!-- <div>
            <div class="circle-container mb-2">
              <span><i class="fa fa-circle" aria-hidden="true" style="color: #e8f5e9;"></i>&nbsp;Closed
                Logs&nbsp;&nbsp;&nbsp;</span>
              <span><i class="fa fa-circle" aria-hidden="true" style="color: #ffe6e6;"></i>&nbsp;Open
                Logs&nbsp;&nbsp;&nbsp;</span>
            </div>
          </div> -->
          <div class="grid align-items-end">

            <div class="col-12 md:col-2 lg:col-2 sm:col-6">
              <label class="bold-red-text" for="productId">Product</label>
              <p-dropdown [options]="filterProductData" [(ngModel)]="selectedProduct" optionLabel="productinitial"
                [showClear]="true" optionValue="productId" (onChange)="getParams2($event,'Product Row')"
                styleClass="w-full">
              </p-dropdown>
            </div>
            <div class="col-12 md:col-2 lg:col-2 sm:col-6">
              <label class="bold-red-text" ,canActivate:[RolegaurdGuard] for="orgId">Organisation</label>
              <p-dropdown [options]="filterOrgData" [(ngModel)]="selectedOrganisation" optionLabel="orgname"
                [showClear]="true" optionValue="orgId" (onChange)="getParams2($event,'Org Row')" styleClass="w-full">
              </p-dropdown>
            </div>

            <div class="col-12 md:col-2 lg:col-2 sm:col-6">
              <label class="label-spacing bold-red-text" for="activeFlag">Log Status</label>
              <p-dropdown [options]="logStatusOption" [(ngModel)]="selectedLogStatus" optionLabel="label"
                optionValue="value" (onChange)="getParams2($event,'Log Status')"
                styleClass="fixed-width-dropdown-filter" [resetFilterOnHide]="true" inputId="activeFlagId"
                [filter]="true" placeholder="Select Status" appendTo="body" pTooltip="Select Status" [showClear]="true">
              </p-dropdown>
            </div>

            <div class="col-12 md:col-2 lg:col-2 sm:col-6">
              <label class="bold-red-text" for="fromdate">From Date</label>
              <p-calendar class="custom-calendar" [showIcon]="true" pTooltip="Select From Date"
                [(ngModel)]="filterinput.fromdate" placeholder="Choose Date" dateFormat="dd-M-yy" [readonlyInput]="true"
                styleClass="pcalendar-readonly w-full" [showOtherMonths]="true" [selectOtherMonths]="true"
                (onSelect)="getdates(filterinput)" (onClearClick)="onclear(filterinput)" inputId="fromdate"
                [showButtonBar]="true" appendTo="body" [maxDate]="today">
              </p-calendar>
              <span *ngIf="fromdateerrorDisplay" style="color:red;">
                Please Choose from date
              </span>
            </div>

            <div class="col-12 md:col-2 lg:col-2 sm:col-6">
              <label class="bold-red-text" for="todate">To Date</label>
              <p-calendar class="custom-calendar" pTooltip="Select To Date" [showIcon]="true"
                [(ngModel)]="filterinput.todate" placeholder="Choose Date" dateFormat="dd-M-yy"
                (onSelect)="getdates(filterinput)" [showOtherMonths]="true" [readonlyInput]="true"
                styleClass="pcalendar-readonly w-full" [selectOtherMonths]="true" (onClearClick)="onclear(filterinput)"
                inputId="todate" [showButtonBar]="true" appendTo="body" [maxDate]="today">
              </p-calendar>
              <span *ngIf="errorDIsplay" style="color:red;">
                To date should be greater than from date
              </span>
              <span *ngIf="todateerrorDIsplay" style="color:red;">
                Please Choose To date
              </span>
            </div>
            <div class="col-12 md:col-2 lg:col-2 sm:col-6">
              <p-button styleClass="refreshbtn reset-btn" class="ml-2" severity="success" (click)="refreshFilters()"
                pTooltip="Reset">
                <i class="fa fa-refresh" aria-hidden="true"></i>
              </p-button>
            </div>
          </div>
          <div class="grid align-items-end" *ngIf="selectedLogStatus == '1' || selectedLogStatus == '-1'">

            <div class="col-12 md:col-2 lg:col-2 sm:col-6">
              <label class="bold-red-text" for="userid">Closed By</label>
              <p-dropdown [options]="filterClosedByData" [(ngModel)]="selectedClosedBy" optionLabel="userName"
                [showClear]="true" optionValue="userid" (onChange)="getParams2($event,'Closed By Row')"
                styleClass="w-full">
              </p-dropdown>
            </div>
          </div>
          <div style="margin-bottom: 1rem; font-weight: bold; font-size: 1rem;color: red;">
            By default, only open error logs for today are displayed.
            Apply filters to view other logs.
          </div>
          <p-table #dt [value]="tableData" [rows]="rowsize" [scrollable]="true" scrollDirection="both"
            scrollHeight="{{commonScrollHeight}}" (sortFunction)="customSort($event)" [customSort]="true"
            [globalFilterFields]="['id','organisation','userName','page','productinitial','methodName','query','createdAt','error','logData','closedBy','closedOn','closureRemarks']"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [sortOrder]="-1"
            (onPage)="handlePageChange($event)" [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true"
            [showCurrentPageReport]="true" [resizableColumns]="true" sortField="id" columnResizeMode="expand"
            [first]="currentPageIndex" paginatorLocale="fa-IR" [paginator]="tableData.length>0"
            responsiveLayout="scroll">
            <!-- search -->
            <ng-template pTemplate="caption">
              <div class="grid table-header">
                <div class="col-12 md:col-10 sm:col-12 lg:col-10">
                  <span class=" p-input-icon-lft">
                    <i icon="pi pi-search"></i>
                    <input class="form-control" pInputText type="text" id="tablesearch"
                      (input)="dt.filterGlobal($any($event.target).value , 'contains') ; searchTerm = $any($event.target).value;"
                      placeholder="Search in Application Logs" class="tablesearch" pTooltip="Enter Search Criteria"
                      tooltipPosition="top" />
                  </span>
                </div>
                <div class="col-12 sm:col-2 md:col-2 sm:col-12 ">
                  <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" style="cursor: pointer;"
                    (click)="showDialog()"></div>
                </div>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th class="tableaction" style="width:7px !important;">
                  Action
                </th>
                <ng-container *ngFor="let col of _selectedColumns">
                  <th pResizableColumn [pSortableColumn]="col.field" *ngIf="col.isChecked" [style.width]="col.width"
                    [style.minWidth]="col.width">
                    {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon>
                    <!-- <p-columnFilter type="text" [field]="col.field" display="menu"></p-columnFilter> -->
                  </th>
                </ng-container>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
              <tr [ngClass]="getRowClass(data)">
                <td class="tableaction-cell" style="width:7px !important;">
                  <span *ngIf="data.isClosed == 0" class="actionItm close-log-action" pTooltip="Mark as Closed"
                    tooltipPosition="left" (click)="show('Close Error Log',data)">
                    <i class="fa fa-check-circle"></i>
                  </span>
                  <span *ngIf="data.isClosed == 1" class="actionItm" pTooltip="View Closure Details"
                    tooltipPosition="left" (click)="show('Closure Data',data)">
                    <i class="fa fa-eye"></i>
                  </span>
                  <span (click)="show('View Closure Data',data)" class="count-badge"
                    [ngClass]="getOccurrenceClass(data.errorCount)" pTooltip="{{ data.errorCount }} occurrence(s)"
                    tooltipPosition="top">
                    {{ data.errorCount }}
                  </span>
                  <span *ngIf="data.isClosed == 0 && allowReminders == 'Y'" class="actionItm email-action"
                    pTooltip="Send Reminder" tooltipPosition="left"
                    (click)="openEmailConfigModal(data.id,data.isClosed); $event.stopPropagation()">
                    <i class="fa fa-envelope"></i>
                    <span class="reminder-count"> {{ data.reminders }} </span>
                  </span>
                  <span *ngIf="data.isClosed == 1 && data.reminders >0" class="actionItm email-action"
                    pTooltip="View Reminder" tooltipPosition="left"
                    (click)="openEmailConfigModal(data.id,data.isClosed); $event.stopPropagation()">
                    <i class="fa fa-envelope"></i>
                    <span class="reminder-count"> {{ data.reminders }} </span>
                  </span>
                </td>
                <ng-container *ngFor="let col of _selectedColumns">
                  <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class" style="vertical-align:top;">
                    <span pTooltip="{{data[col.field]}}" class="wrap-text"
                      [innerHTML]="highlight(data[col.field],searchTerm)">
                    </span>
                  </td>
                </ng-container>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="9" class="datanotfound">
                  No data available
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Top 10 Recurring Errors by Product, Page & Api">

        <p-table #topErrorDt [value]="topErrorSummary" [rows]="10" [scrollable]="true" scrollDirection="both"
          scrollHeight="{{commonScrollHeight}}" sortField="totalOccurrences" [sortOrder]="-1"
          [globalFilterFields]="['productInitial','page','methodName','totalOccurrences','openCount','closedCount']"
          [rowHover]="true" [paginator]="topErrorSummary.length>0" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [resizableColumns]="true"
          columnResizeMode="expand" responsiveLayout="scroll">
          <ng-template pTemplate="caption">
            <div class="grid table-header">
              <div class="col-12 md:col-10 sm:col-12 lg:col-10">
                <span class=" p-input-icon-lft">
                  <i icon="pi pi-search"></i>
                  <input class="form-control" pInputText type="text" id="tablesearch"
                    (input)="topErrorDt.filterGlobal($any($event.target).value , 'contains') ; topErrorSearchTerm = $any($event.target).value;"
                    placeholder="Search in Error Summary" class="tablesearch" pTooltip="Enter Search Criteria"
                    tooltipPosition="top" />
                </span>
              </div>
            </div>
          </ng-template>


          <ng-template pTemplate="header">
            <tr>
              <ng-container *ngFor="let col of _selectedTopErrorCols">
                <th *ngIf="col.isChecked" pResizableColumn [pSortableColumn]="col.field" [style.width]="col.width"
                  [style.minWidth]="col.width">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-data>
            <tr>
              <ng-container *ngFor="let col of _selectedTopErrorCols">
                <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
                  <span class="wrap-text">
                    {{data[col.field]}}
                  </span>
                </td>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="_selectedTopErrorCols.length">
                No data available
              </td>
            </tr>
          </ng-template>

        </p-table>

      </p-tabPanel>
      <p-tabPanel header="Activity Feed">
        <div class="activity-feed-header">
          <div class="activity-feed-title">

            <div class="activity-feed-title-icon">
              <i class="fa fa-rss"></i>
            </div>

            <div>
              <h3>Recent Activity Feed</h3>
              <span>
                Shows errors generated, errors closed, and email reminders sent for the selected date.
              </span>
            </div>
          </div>

          <div class="activity-feed-filters">
            <button type="button" class="activity-filter-chip" [class.active]="activityFilter === 'ALL'"
              (click)="setActivityFilter('ALL')">
              <i class="fa fa-list"></i>
              <span>All</span>
            </button>
            <button type="button" class="activity-filter-chip error-filter" [class.active]="activityFilter === 'ERROR'"
              (click)="setActivityFilter('ERROR')"> 
              <i class="fa fa-exclamation-circle"></i>
              <span>Errors</span>
            </button>
            <button type="button" class="activity-filter-chip closed-filter"
              [class.active]="activityFilter === 'CLOSED'" (click)="setActivityFilter('CLOSED')">
              <i class="fa fa-check-circle"></i>
              <span>Closed Errors</span>
            </button> <button type="button" class="activity-filter-chip reminder-filter"
              [class.active]="activityFilter === 'REMINDER'" (click)="setActivityFilter('REMINDER')"> 
              <i class="fa fa-envelope"></i>
              <span>Reminders</span>
            </button>
          </div>
          <div class="col-12 md:col-2 lg:col-2 sm:col-6">
            <label class="bold-red-text" for="todate">Activity Date</label>
            <p-calendar [(ngModel)]="activityFeedDate" [showIcon]="true" [readonlyInput]="true" dateFormat="dd-M-yy"
              [maxDate]="today" placeholder="Select Date" appendTo="body" pTooltip="Select activity date"
              tooltipPosition="left" (onSelect)="loadActivityFeed()" (onClear)="loadActivityFeed()">
            </p-calendar>
          </div>

          <p-button styleClass="refreshbtn reset-btn" class="ml-2" severity="success" (click)="activityFeedDate = today; 
            loadActivityFeed() " tooltipPosition="left" pTooltip="Refresh">
            <i class="fa fa-refresh" aria-hidden="true"></i>
          </p-button>

        </div>

        <div class="activity-feed-container">

          <div *ngIf="activityFeedLoading" class="feed-loading">
            <i class="pi pi-spin pi-spinner"></i>
            Loading activity...
          </div>

          <div *ngIf="!activityFeedLoading && activityFeed?.length" class="activity-feed-scroll">
            <div class="activity-item" *ngFor="let activity of activityFeed"
              (click)="onActivityClick(activity.logId, activity.activityType,activity.isClosed)" style="cursor: pointer;">

              <div class="activity-avatar" [ngClass]="{
              'error-avatar': activity.activityType === 'ERROR',
              'closed-avatar': activity.activityType === 'CLOSED',
              'reminder-avatar': activity.activityType === 'REMINDER'}">
                {{ getUserInitials(activity.userName) }}
              </div>

              <div class="activity-content">
                <div class="activity-header">
                  <span class="activity-user">
                    {{ activity.userName }}
                  </span>

                  <span class="activity-time">
                    {{ activity.activityTime }}
                  </span>
                </div>

                <div class="activity-text">
                  {{ activity.activityText }}
                </div>

                <div class="activity-details">
                  <span>
                    <i class="fa fa-hashtag"></i>
                    {{ activity.logId }}
                  </span>
                  <span>
                    <i class="fa fa-cubes"></i>
                    {{ activity.product }}
                  </span>

                  <span>
                    <i class="fa fa-building"></i>
                    {{ activity.organisation }}
                  </span>

                  <span>
                    <i class="fa fa-file-text-o"></i>
                    {{ activity.page }}
                  </span>

                </div>
                <div class="activity-message" *ngIf="activity.message">
                  {{ activity.message }}
                </div>
                <div class="activity-remarks" *ngIf="activity.activityType === 'CLOSED' && activity.remarks"> <i
                    class="fa fa-commenting-o"></i> <span>
                    <strong>Closure Remarks:</strong> {{ activity.remarks }} </span> </div>
              </div>
            </div>
          </div>

          <div *ngIf="!activityFeedLoading && (!activityFeed || activityFeed.length === 0)" class="feed-empty">
            <i class="fa fa-inbox"></i>
            <span>No activity available</span>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>

  <div *ngIf="dashboardView=='analytics'">
    <div class="grid align-items-end">

      <div class="col-12 md:col-2 lg:col-2 sm:col-6">
        <label class="bold-red-text" for="productId">Product</label>
        <p-dropdown [options]="filterProductData" [(ngModel)]="selectedProduct" optionLabel="productinitial"
          [showClear]="true" optionValue="productId" (onChange)="getParams2($event,'Product Row')" styleClass="w-full">
        </p-dropdown>
      </div>
      <div class="col-12 md:col-2 lg:col-2 sm:col-6">
        <label class="bold-red-text" ,canActivate:[RolegaurdGuard] for="orgId">Organisation</label>
        <p-dropdown [options]="filterOrgData" [(ngModel)]="selectedOrganisation" optionLabel="orgname"
          [showClear]="true" optionValue="orgId" (onChange)="getParams2($event,'Org Row')" styleClass="w-full">
        </p-dropdown>
      </div>

      <div class="col-12 md:col-2 lg:col-2 sm:col-6">
        <label class="label-spacing bold-red-text" for="activeFlag">Log Status</label>
        <p-dropdown [options]="logStatusOption" [(ngModel)]="selectedLogStatus" optionLabel="label" optionValue="value"
          (onChange)="getParams2($event,'Log Status')" styleClass="fixed-width-dropdown-filter"
          [resetFilterOnHide]="true" inputId="activeFlagId" [filter]="true" placeholder="Select Status" appendTo="body"
          pTooltip="Select Status" [showClear]="true">
        </p-dropdown>
      </div>

      <div class="col-12 md:col-2 lg:col-2 sm:col-6">
        <label class="bold-red-text" for="fromdate">From Date</label>
        <p-calendar class="custom-calendar" [showIcon]="true" pTooltip="Select From Date"
          [(ngModel)]="filterinput.fromdate" placeholder="Choose Date" dateFormat="dd-M-yy" [readonlyInput]="true"
          styleClass="pcalendar-readonly w-full" [showOtherMonths]="true" [selectOtherMonths]="true"
          (onSelect)="getdates(filterinput)" (onClearClick)="onclear(filterinput)" inputId="fromdate"
          [showButtonBar]="true" appendTo="body" [maxDate]="today">
        </p-calendar>
        <span *ngIf="fromdateerrorDisplay" style="color:red;">
          Please Choose from date
        </span>
      </div>

      <div class="col-12 md:col-2 lg:col-2 sm:col-6">
        <label class="bold-red-text" for="todate">To Date</label>
        <p-calendar class="custom-calendar" pTooltip="Select To Date" [showIcon]="true" [(ngModel)]="filterinput.todate"
          placeholder="Choose Date" dateFormat="dd-M-yy" (onSelect)="getdates(filterinput)" [showOtherMonths]="true"
          [readonlyInput]="true" styleClass="pcalendar-readonly w-full" [selectOtherMonths]="true"
          (onClearClick)="onclear(filterinput)" inputId="todate" [showButtonBar]="true" appendTo="body"
          [maxDate]="today">
        </p-calendar>
        <span *ngIf="errorDIsplay" style="color:red;">
          To date should be greater than from date
        </span>
        <span *ngIf="todateerrorDIsplay" style="color:red;">
          Please Choose To date
        </span>
      </div>
      <div class="col-12 md:col-2 lg:col-2 sm:col-6">
        <p-button styleClass="refreshbtn reset-btn" class="ml-2" severity="success" (click)="refreshFilters()"
          pTooltip="Reset">
          <i class="fa fa-refresh" aria-hidden="true"></i>
        </p-button>
      </div>
    </div>

    <div class="grid">
      <div class="col-12">
        <div class="card chart">

          <div class="report-header">

            <div class="week-navigation">

              <button pButton type="button" icon="pi pi-chevron-left" class="week-nav-btn previous-btn"
                (click)="previousTrendWeek()" pTooltip="Previous Week">
              </button>

              <div class="week-info">

                <div class="week-label">
                  <i class="pi pi-calendar"></i>
                  Weekly Error Trend
                </div>

                <div class="week-range-chip">
                  {{ weekTrendRange || 'Last 7 Days' }}
                </div>

              </div>

              <button pButton type="button" icon="pi pi-chevron-right" class="week-nav-btn next-btn"
                [disabled]="weekTrendOffset==0" (click)="nextTrendWeek()" pTooltip="Next Week">
              </button>

            </div>

            <div class="chart-filter-chips" *ngIf="hasFilters()">

              <span class="filter-chip" *ngIf="selectedProduct">
                <i class="pi pi-box"></i>
                {{ getSelectedProductName() }}
              </span>

              <span class="filter-chip" *ngIf="selectedOrganisation">
                <i class="pi pi-building"></i>
                {{ getSelectedOrganisationName() }}
              </span>

            </div>

          </div>

          <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions"
            style="width:100%;height:400px;display:block;">
          </highcharts-chart>

        </div>
      </div>

      <div class="col-6">
        <div class="card chart">
          <div class="report-header">
            <h4 class="report-title-text">
              Total Errors
            </h4>
            <div class="chart-filter-chips" *ngIf="hasFilters()">
              <span class="filter-chip" *ngIf="selectedProduct">
                <i class="pi pi-box"></i>
                {{ getSelectedProductName() }}
              </span>

              <span class="filter-chip" *ngIf="selectedOrganisation">
                <i class="pi pi-building"></i>
                {{ getSelectedOrganisationName() }}
              </span>
              <span class="filter-chip" *ngIf="filtersData['tfromdate'] && filtersData['ttodate']">
                <i class="pi pi-calendar"></i>
                {{ filtersData['tfromdate'] }} - {{ filtersData['ttodate'] }}
              </span>
            </div>
          </div>

          <highcharts-chart [Highcharts]="Highcharts" [options]="statusChartOptions"
            style="width:100%;height:400px;display:block;">
          </highcharts-chart>

        </div>
      </div>

      <div class="col-6">
        <div class="card chart">
          <div class="report-header">
            <h4 class="report-title-text">
              Open Errors By Product
            </h4>
            <div class="chart-filter-chips" *ngIf="hasFilters()">
              <span class="filter-chip" *ngIf="selectedProduct">
                <i class="pi pi-box"></i>
                {{ getSelectedProductName() }}
              </span>

              <span class="filter-chip" *ngIf="selectedOrganisation">
                <i class="pi pi-building"></i>
                {{ getSelectedOrganisationName() }}
              </span>
              <span class="filter-chip" *ngIf="filtersData['tfromdate'] && filtersData['ttodate']">
                <i class="pi pi-calendar"></i>
                {{ filtersData['tfromdate'] }} - {{ filtersData['ttodate'] }}
              </span>
            </div>
          </div>

          <highcharts-chart [Highcharts]="Highcharts" [options]="openLogsByProduct"
            style="width:100%;height:400px;display:block;">
          </highcharts-chart>

        </div>
      </div>

      <div class="col-12">
        <div class="card chart">

          <div class="report-header">
            <h4 class="report-title-text">
              Error status by Product
            </h4>
            <div class="chart-filter-chips" *ngIf="hasFilters()">
              <span class="filter-chip" *ngIf="selectedProduct">
                <i class="pi pi-box"></i>
                {{ getSelectedProductName() }}
              </span>

              <span class="filter-chip" *ngIf="selectedOrganisation">
                <i class="pi pi-building"></i>
                {{ getSelectedOrganisationName() }}
              </span>

              <!-- <span class="filter-chip">
                <i class="pi pi-filter"></i>
                {{ getSelectedStatusName() }}
              </span> -->

              <span class="filter-chip" *ngIf="filtersData['tfromdate'] && filtersData['ttodate']">
                <i class="pi pi-calendar"></i>
                {{ filtersData['tfromdate'] }} - {{ filtersData['ttodate'] }}
              </span>
            </div>
          </div>

          <highcharts-chart [Highcharts]="Highcharts" [options]="productChartOptions"
            style="width:100%;height:400px;display:block;">
          </highcharts-chart>

        </div>
      </div>
      <div class="col-12">
        <div class="card chart">

          <div class="report-header">
            <div class="week-navigation">

              <button pButton type="button" icon="pi pi-chevron-left" class="week-nav-btn previous-btn"
                (click)="previousWeek()" pTooltip="Previous Week">
              </button>

              <div class="week-info">

                <div class="week-label">
                  <i class="pi pi-calendar"></i>
                  Weekly Error Heatmap
                </div>

                <div class="week-range-chip">
                  {{weekRange}}
                </div>

              </div>

              <button pButton type="button" icon="pi pi-chevron-right" class="week-nav-btn next-btn"
                [disabled]="weekOffset==0" (click)="nextWeek()" pTooltip="Next Week">
              </button>

            </div>
            <div class="chart-filter-chips" *ngIf="hasFilters()">
              <span class="filter-chip" *ngIf="selectedProduct">
                <i class="pi pi-box"></i>
                {{ getSelectedProductName() }}
              </span>

              <span class="filter-chip" *ngIf="selectedOrganisation">
                <i class="pi pi-building"></i>
                {{ getSelectedOrganisationName() }}
              </span>
            </div>
          </div>

          <highcharts-chart [Highcharts]="Highcharts" [options]="heatMapOptions"
            style="width:100%;height:500px;display:block">
          </highcharts-chart>

        </div>
      </div>

      <div class="col-12">
        <div class="card chart">

          <div class="report-header">
            <h4 class="report-title-text">
              Daily Open vs Closed Trend
            </h4>
            <div class="chart-filter-chips" *ngIf="hasFilters()">
              <span class="filter-chip" *ngIf="selectedProduct">
                <i class="pi pi-box"></i>
                {{ getSelectedProductName() }}
              </span>

              <span class="filter-chip" *ngIf="selectedOrganisation">
                <i class="pi pi-building"></i>
                {{ getSelectedOrganisationName() }}
              </span>
            </div>

          </div>

          <highcharts-chart [Highcharts]="Highcharts" [options]="dailyTrendOptions"
            style="width:100%; height:400px; display:block;">
          </highcharts-chart>

        </div>
      </div>
      <div class="col-12">
        <div class="card chart">

          <div class="report-header">

            <h4 class="report-title-text">
              Open Errors Age
            </h4>

            <div class="header-right">

              <div class="chart-filter-chips" *ngIf="hasFilters()">
                <span class="filter-chip" *ngIf="selectedProduct">
                  <i class="pi pi-box"></i>
                  {{ getSelectedProductName() }}
                </span>

                <span class="filter-chip" *ngIf="selectedOrganisation">
                  <i class="pi pi-building"></i>
                  {{ getSelectedOrganisationName() }}
                </span>
              </div>

              <div class="view-toggle">
                <button pButton type="button" label="D" class="p-button-sm" pTooltip="Show error age grouped by days"
                  tooltipPosition="left" [ngClass]="errorAgeView === 'day' ? 'active-toggle' : 'inactive-toggle'"
                  (click)="changeErrorAgeView('day')">
                </button>

                <button pButton type="button" label="M" class="p-button-sm" pTooltip="Show error age grouped by months"
                  tooltipPosition="left" [ngClass]="errorAgeView === 'month' ? 'active-toggle' : 'inactive-toggle'"
                  (click)="changeErrorAgeView('month')">
                </button>
              </div>

            </div>
          </div>

          <highcharts-chart [Highcharts]="Highcharts" [options]="errorAgeChartOptions"
            style="width:100%;height:340px;display:block">
          </highcharts-chart>

        </div>
      </div>


    </div>
  </div>
</p-card>

<p-dialog header="Send Reminder" [(visible)]="showEmailConfig" [modal]="true" [closable]="true" [draggable]="false"
  [resizable]="false" [style]="{ width: '700px' }" appendTo="body">

  <div class="email-config-container">

    <div *ngIf="allowSendingEmail === 1" class="field">
      <label for="techUsers" class="bold-red-text">
        Select Users
      </label>

      <p-multiSelect [options]="techUsers" id="techUsers" [(ngModel)]="selectedTechUsers" name="techUsers"
        placeholder="Select Users" optionLabel="emailaddr" optionValue="emailaddr" appendTo="body"
        [resetFilterOnHide]="true" [filter]="true" [showClear]="true" styleClass="w-full">
      </p-multiSelect>
    </div>

    <div class="reminder-table-container mt-3">

      <p-table #reminderDt [value]="reminderData" [rows]="5" [paginator]="reminderData?.length > 0"
        [rowsPerPageOptions]="[5, 10, 20]" [scrollable]="true" scrollHeight="250px" responsiveLayout="scroll"
        styleClass="p-datatable-sm" [globalFilterFields]="['sno', 'remindedBy', 'remindedTo', 'remindedOn']"
        [resizableColumns]="true" columnResizeMode="expand" [rowHover]="true" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

        <ng-template pTemplate="caption">
          <div class="table-header">
            <span class="p-input-icon-left w-full">

              <input pInputText type="text" class="form-control tablesearch w-full"
                placeholder="Search Reminder History" pTooltip="Enter Search Criteria" tooltipPosition="top"
                (input)="reminderDt.filterGlobal($any($event.target).value, 'contains')" />
            </span>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>

            <th pResizableColumn pSortableColumn="sno">
              Sno
              <p-sortIcon field="sno"></p-sortIcon>
            </th>

            <th pResizableColumn pSortableColumn="remindedBy">
              Reminded By
              <p-sortIcon field="remindedBy"></p-sortIcon>
            </th>

            <th pResizableColumn pSortableColumn="remindedTo">
              Reminded To
              <p-sortIcon field="remindedTo"></p-sortIcon>
            </th>

            <th pResizableColumn pSortableColumn="remindedOn">
              Reminded On
              <p-sortIcon field="remindedOn"></p-sortIcon>
            </th>

          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>

            <td>
              <span class="wrap-text">
                {{ row.sno }}
              </span>
            </td>

            <td>
              <span class="wrap-text">
                {{ row.remindedBy }}
              </span>
            </td>

            <td>
              <span class="wrap-text">
                {{ row.remindedTo }}
              </span>
            </td>

            <td>
              <span class="wrap-text">
                {{ row.remindedOn }}
              </span>
            </td>

          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center">
              No reminder history available.
            </td>
          </tr>
        </ng-template>

      </p-table>

    </div>

  </div>

  <ng-template pTemplate="footer">

    <button pButton type="button" label="Cancel" icon="pi pi-times" class="p-button-secondary"
      (click)="showEmailConfig = false">
    </button>

    <button *ngIf="allowSendingEmail === 1" pButton type="button"
      [label]="isSendingReminder ? 'Sending...' : 'Send Email'" icon="pi pi-check" class="p-button-success"
      [disabled]="!selectedTechUsers || selectedTechUsers.length === 0" (click)="sendErrorReminder()">
    </button>

  </ng-template>

</p-dialog>